// removed by extract-text-webpack-plugin
module.exports = {"component":"_3o3a6DaDN2E_GmaMRWDwr3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/ConfigCurrency/configCurrency.css
// module id = 1095
// module chunks = 2